module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "klass": 'ls-modal-large'
    },
    model: {
      value: (_vm.value.show),
      callback: function($$v) {
        _vm.value.show = $$v
      },
      expression: "value.show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('entries.add_entry')))])]), _vm._v(" "), _c('form', {
    staticClass: "ls-form ls-form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "ls-modal-body",
    attrs: {
      "data-test": "entries"
    }
  }, [_c('div', {
    staticClass: "ls-alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('application.alert.warning')))]), _vm._v(" " + _vm._s(_vm.$t('entries.add_entry_message')) + "\n        ")]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "create_entry"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('entries.next_invoice_information')))]), _vm._v(" "), _c('fieldset', {
    staticClass: "ls-md-margin-bottom row"
  }, [_c('label', {
    staticClass: "ls-label col-md-3 col-xs-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('entries.type'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('entries.type')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-custom-select"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.type),
      expression: "newEntry.type"
    }],
    staticClass: "ls-custom",
    attrs: {
      "data-test": "entry.type",
      "name": _vm.$t('entries.type')
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newEntry.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('entries.addition')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('entries.discount')))])])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('entries.type'))),
      expression: "errors.has($t('entries.type'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('entries.type'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-4 col-xs-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('entries.description'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('entries.description')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.description),
      expression: "newEntry.description"
    }],
    staticClass: "ls-field",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "data-test": "entry.description",
      "placeholder": _vm.$t('entries.placeholder.add_entry'),
      "name": _vm.$t('entries.description')
    },
    domProps: {
      "value": (_vm.newEntry.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEntry.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('entries.description'))),
      expression: "errors.has($t('entries.description'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('entries.description'))))]), _vm._v(" "), _c('char-counter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.$t('entries.description'))),
      expression: "!errors.has($t('entries.description'))"
    }],
    attrs: {
      "max": 40
    },
    model: {
      value: (_vm.newEntry.description),
      callback: function($$v) {
        _vm.newEntry.description = $$v
      },
      expression: "newEntry.description"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-3 col-xs-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('entries.value'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('entries.value')))]), _vm._v(" "), _c('money-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "value": _vm.newEntry.price,
      "dataTest": 'entry.price',
      "name": _vm.$t('entries.value')
    },
    on: {
      "updateValue": function (value) {
        _vm.newEntry.price = value
      }
    },
    model: {
      value: (_vm.newEntry.price),
      callback: function($$v) {
        _vm.newEntry.price = $$v
      },
      expression: "newEntry.price"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('entries.value'))),
      expression: "errors.has($t('entries.value'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('entries.value'))))])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-action ls-float-right"
  }, [_c('button', {
    staticClass: "ls-btn"
  }, [_vm._v(_vm._s(_vm.$t('application.button.include')))])])])]), _vm._v(" "), (_vm.entries.length > 0) ? _c('div', [_c('h5', {
    staticClass: "ls-title-5"
  }, [_vm._v(_vm._s(_vm.$t('entries.additional_entries_next_invoice')))]), _vm._v(" "), _c('table', {
    staticClass: "ls-table entries-table ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "ls-txt-left"
  }, [_vm._v(_vm._s(_vm.$t('entries.type')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-left"
  }, [_vm._v(_vm._s(_vm.$t('entries.description')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-right"
  }, [_vm._v(_vm._s(_vm.$t('entries.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.entries), function(entry) {
    return [(entry.launched === false) ? _c('tr', [(entry.price >= 0) ? _c('td', {
      staticClass: "ls-txt-left"
    }, [_vm._v(_vm._s(_vm.$t('entries.addition')))]) : _c('td', {
      staticClass: "ls-txt-left"
    }, [_vm._v(_vm._s(_vm.$t('entries.discount')))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-left"
    }, [_vm._v(_vm._s(entry.description))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-right"
    }, [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(entry.price)))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-center"
    }, [_c('authorized-link', {
      attrs: {
        "tag": "destroy_entry"
      }
    }, [(!_vm.cannotBeDeleted(entry)) ? _c('button', {
      staticClass: "ls-btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeEntry(entry)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.preventDefault();
          _vm.removeEntry(entry, _vm.description, _vm.price)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('entries.button.remove')))]) : _vm._e()])], 1)]) : _vm._e()]
  })], 2)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer"
  }, [_c('button', {
    staticClass: "ls-btn ls-float-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "close-modal": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2253c294"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/entries/components/ModalAddEntry.vue
// module id = 743
// module chunks = 1